class FAQAccordion extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.querySelector('.faq__answer-wrapper');
    
    if (!this.details || !this.summary || !this.content) return;
    
    this.summary.addEventListener('click', this.handleSummaryClick.bind(this));
    this.details.addEventListener('toggle', this.handleToggle.bind(this));
    this.isAnimating = false;
  }
  
  handleSummaryClick(e) {
    // If we're about to close, prevent default and handle it ourselves
    if (this.details.hasAttribute('open') && !this.isAnimating) {
      e.preventDefault();
      this.close();
    }
  }
  
  close() {
    if (this.isAnimating) return;
    this.isAnimating = true;
    
    // Rotate icon immediately
    this.classList.add('faq__accordion--closing');
    
    // Get current height
    const height = this.content.scrollHeight;
    this.content.style.height = height + 'px';
    this.content.style.overflow = 'hidden';
    
    // Force reflow
    void this.content.offsetHeight;
    
    // Animate to 0
    requestAnimationFrame(() => {
      this.content.style.height = '0px';
      
      this.content.addEventListener('transitionend', () => {
        // Now actually close the details element
        this.details.removeAttribute('open');
        this.content.style.height = '';
        this.content.style.overflow = '';
        this.classList.remove('faq__accordion--closing');
        this.isAnimating = false;
      }, { once: true });
    });
  }
  
  handleToggle() {
    if (!this.content || this.isAnimating) return;
    
    if (this.details.hasAttribute('open')) {
      // Opening: measure actual height and animate
      this.isAnimating = true;
      this.content.style.height = '0px';
      this.content.style.overflow = 'hidden';
      
      requestAnimationFrame(() => {
        const height = this.content.scrollHeight;
        this.content.style.height = height + 'px';
        
        this.content.addEventListener('transitionend', () => {
          this.content.style.height = 'auto';
          this.isAnimating = false;
        }, { once: true });
      });
    }
  }
}

customElements.define('faq-accordion', FAQAccordion);

